import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'actionCost',
    serviceName: 'unitadmin',
    query: gql`
      query actionCost(
        $ids: [String]
      ) {
        actionCost(
          ids: $ids
        ) {
          data {
            id
            lab {
              id
              title
            }
            action {
              id
              title
            }
            price
            is_active
            details
          }
        }
      }
    `,
  },
  update: {
    name: 'updateActionCost',
    serviceName: 'labadmin',
    query: gql`
      mutation updateActionCost(
        $ids: [String]!
        $lab_id: String
        $action_id: String
        $price: String
        $is_active: Int
        $details: String
      ) {
        updateActionCost(
          ids: $ids
          lab_id: $lab_id
          action_id: $action_id
          price: $price
          is_active: $is_active
          details: $details
        ) {
          model {
            id
            price
          }
          messages
          influenced_count
        }
      }
    `,
  },
};

export default schema;
